import { SetupStep } from '@modules/WalletSetup/components/SetupStep'
import { ensurePlugbookRecord } from '@plug-core/providers/WalletProvider'
import { useCurrentWallet } from '@plug-core/state'
import { Button, Text } from '@ui'
import { disconnect } from '@utils/disconnect'
import React, { useState } from 'react'

const AuthorizePlugbookCall = () => {
  const [loading, setLoading] = useState(false)
  const { currentWallet } = useCurrentWallet()

  const handleAuthorize = async () => {
    setLoading(true)

    try {
      await ensurePlugbookRecord(currentWallet)
    } finally {
      setLoading(false)
    }
  }

  return (
    <SetupStep
      title="Introducing Plugbook"
      description="Plugbook is Plug Wallet's internal naming service, designed to make sending and receiving assets easier & safer."
    >
      <div className="flex flex-col gap-2">
        <Text variant="body-s" tone="fg-2" align="center">
          Please authorize call to Plugbook service provider, to generate a random, unique
          identifier for your new wallet.
        </Text>

        <Text variant="body-s" tone="fg-2" align="center">
          You can later change and customize your Plugbook identifier
        </Text>
      </div>

      <div className="flex flex-col items-center gap-4">
        <Button
          variant="primary"
          onClick={handleAuthorize}
          loading={loading}
          disabled={loading}
          fullWidth
        >
          Generate my Plugbook identifier
        </Button>

        <Button variant="ghost" size="sm" onClick={disconnect} className="text-fg-2">
          Choose other sign in method
        </Button>
      </div>
    </SetupStep>
  )
}

export default AuthorizePlugbookCall
